"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

/**
 * Позволяет оборачиваемому элементу реализовать анимации появления/скрытия.
 *
 * Например совместо с `@renderToLayer`:
 * - после монтирования в DOM происходит анимация появления
 * - перед размонтированием - анимация скрытия
 *
 *  @renderToLayer
 *  class Popup extends Component {
 *
 *    render() {
 *      return (
 *        <VisibilityAnimation
 *          isVisible={this.props.isOpened}
 *          animationDuration={200}
 *          onVisible={this.props.onOpen}
 *          onInvisible={this.props.onClose}>
 *          {({isVisible}) => (
 *            <div className={`${css.normal} ${isVisible && css.active}`}>
 *              Some content...
 *            </div>
 *          )}
 *          {children}
 *         </VisibilityAnimation>
 *       )
 *     }
 *
 *  }
 */
var VisibilityAnimation = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(VisibilityAnimation, _PureComponent);

  var _super = _createSuper(VisibilityAnimation);

  function VisibilityAnimation() {
    var _this;

    (0, _classCallCheck2.default)(this, VisibilityAnimation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.status = null;
    _this.state = {
      isVisible: false
    };

    _this.show = function () {
      if (_this.status === 'showing') return;
      _this.status = 'showing';

      _this.props.onWillVisible();

      clearTimeout(_this.animationTimeout);

      _this.setState({
        isVisible: true
      });

      _this.animationTimeout = setTimeout(function () {
        _this.status = null;

        _this.props.onVisible();
      }, _this.props.animationDuration);
    };

    _this.hide = function () {
      if (_this.status === 'hiding') return;
      _this.status = 'hiding';

      _this.props.onWillInvisible();

      clearTimeout(_this.animationTimeout);

      _this.setState({
        isVisible: false
      });

      _this.animationTimeout = setTimeout(function () {
        _this.status = null;

        _this.props.onInvisible();
      }, _this.props.animationDuration);
    };

    return _this;
  }

  (0, _createClass2.default)(VisibilityAnimation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isVisible) this.delayTimeout = setTimeout(this.show, 60);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isVisible !== this.props.isVisible) {
        clearTimeout(this.delayTimeout);
        if (this.props.isVisible) this.delayTimeout = setTimeout(this.show, 60);else this.hide();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.delayTimeout);
      clearTimeout(this.animationTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var isVisible = this.state.isVisible;
      return this.props.children({
        isVisible: isVisible
      });
    }
  }]);
  return VisibilityAnimation;
}(_react.PureComponent);

exports.default = VisibilityAnimation;
VisibilityAnimation.defaultProps = {
  isVisible: false,
  onWillVisible: function onWillVisible() {},
  onVisible: function onVisible() {},
  onWillInvisible: function onWillInvisible() {},
  onInvisible: function onInvisible() {}
};
VisibilityAnimation.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Контролирует видимость
   */
  isVisible: _propTypes.default.bool,

  /**
   * Таймаут для анимации в ms
   */
  animationDuration: _propTypes.default.number.isRequired,

  /**
   * Коллбек вызывающийся перед показом
   */
  onWillVisible: _propTypes.default.func,

  /**
   * Коллбек вызывающийся после показа
   */
  onVisible: _propTypes.default.func,

  /**
   * Коллбек вызывающийся перед скрытием
   */
  onWillInvisible: _propTypes.default.func,

  /**
   * Коллбек вызывающийся после скрытия
   */
  onInvisible: _propTypes.default.func,

  /**
   * Фабрика контента
   */
  children: _propTypes.default.func
} : {};